// extracted by mini-css-extract-plugin
module.exports = {"base":"CheckBox_base__UNm2p","input":"CheckBox_input__1XxyM","label":"CheckBox_label__2UhWG","imgDiv":"CheckBox_imgDiv__2H-if","img":"CheckBox_img__1jSiP"};